export default "__VITE_ASSET__BFyvqkM8__"